import { useCallback, useContext } from "react";

import { formatNumber } from "../utils/numberformat";
import { StoreContext } from "../store";

export default function useFormatNumber() {
  const store = useContext(StoreContext);

  return useCallback(
    (value, style = "currency", minimumFractionDigits, currency) => {
      if (style === "currency") {
        const currencyValue = formatNumber(
          store.organization.selected.locale,
          currency || store.organization.selected.currency,
          value,
          minimumFractionDigits,
        );

        const formattedValue = currencyValue.replace(/[\,\.]\d{2}$/, "");

        return formattedValue;
      }

      if (style === "percent") {
        return Number(value).toLocaleString(store.organization.selected.locale, {
          style: "percent",
          minimumFractionDigits,
        });
      }
    },
    [store.organization.selected.currency, store.organization.selected.locale],
  );
}
